import React from "react";
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../LayoutAside"
import Button from "../../../components/buttons";
import userRestRepository from "common/user/repository/UserRestRepository";

export default ContentsContainer;

function ContentsContainer(props: any) {


    const signData = "전자서명";

    const onClickHandler = async () => {
        const result = await userRestRepository.certify(signData);
        console.log("전자서명 결과", result);
    }

    return (
        <PageContainer session={false}>
            <LayoutAside/>
            <div className="fww-con">
                <main className="fww-main">
                    <div className="fo fo-col3 mb10">
                        <Button color='pri' size="md" onClick={onClickHandler}>전자서명하기</Button>
                    </div>
                </main>
            </div>
        </PageContainer>
    );
}
